import { render, staticRenderFns } from "./IdentityVerificationConfirm.vue?vue&type=template&id=3a8f2e71&"
import script from "./IdentityVerificationConfirm.vue?vue&type=script&lang=ts&"
export * from "./IdentityVerificationConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports